"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardBrand = void 0;
/**
 * Interface which represents the card brand
 */
var CardBrand;
(function (CardBrand) {
    CardBrand["AMEX"] = "american_express";
    CardBrand["DINERS"] = "diners_club";
    CardBrand["ELO"] = "elo";
    CardBrand["HIPERCARD"] = "hipercard";
    CardBrand["MASTERCARD"] = "mastercard";
    CardBrand["VISA"] = "visa";
})(CardBrand = exports.CardBrand || (exports.CardBrand = {}));
